import type { PmTone } from "./aqi";

export type Theme = "light" | "dark";

export const THEME_STORAGE_KEY = "levego-theme";

export function resolveInitialTheme(): Theme {
  try {
    const stored = localStorage.getItem(THEME_STORAGE_KEY);
    if (stored === "light" || stored === "dark") return stored;
  } catch {
    /* ignore */
  }
  return "dark";
}

export function applyTheme(theme: Theme): void {
  const root = document.documentElement;
  root.setAttribute("data-theme", theme);
  root.style.colorScheme = theme;

  let meta = document.querySelector('meta[name="color-scheme"]');
  if (!meta) {
    meta = document.createElement("meta");
    meta.setAttribute("name", "color-scheme");
    document.head.appendChild(meta);
  }
  meta.setAttribute("content", theme);

  let themeColor = document.querySelector('meta[name="theme-color"]');
  if (!themeColor) {
    themeColor = document.createElement("meta");
    themeColor.setAttribute("name", "theme-color");
    document.head.appendChild(themeColor);
  }
  themeColor.setAttribute(
    "content",
    theme === "light" ? "#e9f0f2" : "#0b1216",
  );

  try {
    localStorage.setItem(THEME_STORAGE_KEY, theme);
  } catch {
    /* ignore */
  }
}

export function readCssVar(name: string): string {
  return getComputedStyle(document.documentElement)
    .getPropertyValue(name)
    .trim();
}

export type ChartColors = {
  text: string;
  textMuted: string;
  line: string;
  grid: string;
  elevated: string;
  accent: string;
  good: string;
  moderate: string;
  poor: string;
  bad: string;
  chartMean: string;
};

export function readChartColors(): ChartColors {
  return {
    text: readCssVar("--text"),
    textMuted: readCssVar("--text-muted"),
    line: readCssVar("--line"),
    grid: readCssVar("--chart-grid"),
    elevated: readCssVar("--bg-elevated"),
    accent: readCssVar("--accent"),
    good: readCssVar("--good"),
    moderate: readCssVar("--moderate"),
    poor: readCssVar("--poor"),
    bad: readCssVar("--bad"),
    chartMean: readCssVar("--chart-mean"),
  };
}

export function toneChartColor(tone: PmTone, colors: ChartColors): string {
  switch (tone) {
    case "good":
      return colors.good;
    case "moderate":
      return colors.moderate;
    case "poor":
      return colors.poor;
    case "bad":
      return colors.bad;
  }
}
